/* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

import { SalesCommissionState, SalesCommissionStateRecord } from "./commission.state";
import * as actions from '../commission-action/commission.action';


export const initialState: SalesCommissionState = new SalesCommissionStateRecord() as unknown as SalesCommissionState;

export function reducer(
  state = initialState, { 
    type, payload 
  }: any
): SalesCommissionState {
  if (!type) {
    return state;
  }

  switch (type) {

    // <------------------Commission LIST--------------------> //
    case actions.ActionTypes.GET_COMMISSION_LIST_ACTION: {
      return Object.assign({}, state, {
        commissionList: [],
        commissionLoading: true,
        commissionListLoaded: false,
        commissionListFailed: false,
      });
    }

    case actions.ActionTypes.GET_COMMISSION_SUCCESS: {
      let tempCommissionList = [];
      if (payload.data && payload.data.length > 0) {
        tempCommissionList = payload.data.map(element => {
          return { ...element, isCollapsed: true };
        });
      }
      return Object.assign({}, state, {
        commissionList: tempCommissionList,
        commissionListLoading: false,
        commissionListLoaded: true,
        commissionListFailed: false,
      });
    }

    case actions.ActionTypes.GET_COMMISSION_FAIL: {
      return Object.assign({}, state, {
        commissionList: [],
        commissionListLoading: false,
        commissionListLoaded: false,
        commissionListFailed: true,
      });
    }

    // <------------------Commission LIST COUNT--------------------> //
    case actions.ActionTypes.GET_COMMISSION_LIST_COUNT_ACTION: {
      return Object.assign({}, state, {
        commissionListCount: [],
        commissionListCountLoading: true,
        commissionListCountLoaded: false,
        commissionListCountFailed: false,
      });
    }

    case actions.ActionTypes.GET_COMMISSION_LIST_COUNT_SUCCESS: {
      return Object.assign({}, state, {
        commissionListCount: payload,
        commissionListCountLoading: false,
        commissionListCountLoaded: true,
        commissionListCountFailed: false,
      });
    }

    case actions.ActionTypes.GET_COMMISSION_LIST_COUNT_FAIL: {
      return Object.assign({}, state, {
        commissionListCount: [],
        commissionListCountLoading: false,
        commissionListCountLoaded: false,
        commissionListCountFailed: true,
      });
    }

    default: {
      return state;
    }
  }
}

export const commissionList = (state: SalesCommissionState) => state.commissionList;
export const commissionListLoading = (state: SalesCommissionState) => state.commissionListLoading;
export const commissionListLoaded = (state: SalesCommissionState) => state.commissionListLoaded;
export const commissionListFailed = (state: SalesCommissionState) => state.commissionListFailed;

export const commissionListCount = (state: SalesCommissionState) => state.commissionListCount;
export const commissionListCountLoading = (state: SalesCommissionState) => state.commissionListCountLoading;
export const commissionListCountLoaded = (state: SalesCommissionState) => state.commissionListCountLoaded;
export const commissionListCountFailed = (state: SalesCommissionState) => state.commissionListCountFailed;